import { useState } from 'react';
import Select, { SelectValue } from '@components/atoms/Select';

import { useLeagueContext } from '@hooks/useLeagueContext';
import { FIXTURE_OPTIONS, CURRENT_SEASON, MAX_GAMEWEEK } from '@lib/constants';
import GameweekRangeSlider from '@components/fpl-ui/gameweek-range-slider';

const FixtureFilter = ({
  onUpdate,
  initialState
}: {
  initialState: {
    maxGW: number;
    minGW: number;
    season: number;
    venue: string | number;
  };
  onUpdate: (gameweekRange: any[], venue: string | number, season: any) => void;
}) => {
  const { context } = useLeagueContext();
  const currentGameweek = context?.currentGameweek?.number ?? null;

  const toolSeasonLabelEnd = (initialState.season + 1).toString(10).slice(-2);
  const venueOptions = [
    { value: 'all', label: 'All' },
    { value: 'home', label: 'Home' },
    { value: 'away', label: 'Away' }
  ];
  const initialVenue = venueOptions.find(
    (option) => option.value === initialState.venue
  );
  const [venue, setVenue] = useState<SelectValue>(
    initialVenue || venueOptions[0]
  );

  const [season, setSeason] = useState<SelectValue>({
    value: initialState.season,
    label: `${initialState.season}/${toolSeasonLabelEnd}`
  });
  const [range, setRange] = useState<[number, number]>([
    initialState.minGW,
    getMaxGameWeek()
  ]);

  const handleRangeCommit = (newValue: [number, number]) => {
    setRange(newValue);
    onUpdate(newValue, venue.value, season.value);
  };

  function updateVenue(venue: SelectValue) {
    setVenue(venue);
    onUpdate(range, venue.value, season.value);
  }

  function updateSeason(season: SelectValue) {
    setSeason(season);
    onUpdate(range, venue.value, season.value);
  }

  function getMaxGameWeek() {
    if (Number(season.value) < CURRENT_SEASON) {
      return MAX_GAMEWEEK;
    }
    // `currentGameweek` is null until GameweekContextSync resolves
    // /league/context. Fall back to the season cap so the slider stays
    // valid through that window instead of collapsing to max=0.
    return currentGameweek == null ? MAX_GAMEWEEK : Number(currentGameweek);
  }

  return (
    <div className="space-y-3">
      <GameweekRangeSlider
        name="gameweek-slider"
        onCommit={handleRangeCommit}
        min={1}
        max={getMaxGameWeek()}
        value={range}
      />
      <div className="grid gap-3 sm:grid-cols-2">
        <Select
          name="venue"
          onChange={updateVenue}
          label="Venue"
          options={venueOptions}
          value={venue}
        />
        <Select
          name="season"
          onChange={updateSeason}
          label="Season"
          options={FIXTURE_OPTIONS}
          value={season}
        />
      </div>
    </div>
  );
};

export default FixtureFilter;
